import { render, staticRenderFns } from "./GoodsType.vue?vue&type=template&id=19e02f1e&scoped=true&"
import script from "./GoodsType.vue?vue&type=script&lang=js&"
export * from "./GoodsType.vue?vue&type=script&lang=js&"
import style0 from "./GoodsType.vue?vue&type=style&index=0&id=19e02f1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e02f1e",
  null
  
)

export default component.exports